import { supabase } from '@/lib/supabase'

type Section = 'sidebar_icon' | 'sidebar_logo' | 'home' | 'login' | 'maintenance' | 'pwa_icon'

let cache: any | null = null

export async function getBranding(): Promise<any> {
  if (cache) return cache
  const { data, error } = await supabase.rpc('get_logo_config')
  if (error) throw error
  cache = data || {}
  return cache
}

export function invalidateBranding() {
  cache = null
}

export async function getLogo(section: Section, light: boolean): Promise<string | null> {
  const b = await getBranding()
  const obj = b?.[section]
  return light ? (obj?.light || null) : (obj?.dark || null)
}

export async function setLogoConfig(section: Section, lightUrl: string | null, darkUrl: string | null): Promise<void> {
  const { error } = await supabase.rpc('set_logo_config', {
    p_section: section,
    p_light: lightUrl ?? '',
    p_dark: darkUrl ?? '',
  })
  if (error) throw error
  invalidateBranding()
}
